import styled from "styled-components"

export const Container = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    h1 {
        font-size: 2.25rem;
        font-weight: 700;
    }
`;